function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.33722 6.39777L11.0528 0.360269C11.0653 0.344493 11.073 0.325533 11.0751 0.305568C11.0772 0.285603 11.0737 0.265441 11.0649 0.247399C11.0561 0.229357 11.0424 0.214166 11.0253 0.203571C11.0082 0.192976 10.9885 0.187406 10.9685 0.187501L9.9332 0.187501C9.86757 0.187501 9.80463 0.218305 9.76445 0.269198L5.99972 5.09063L2.23498 0.269198C2.19481 0.216966 2.13186 0.187501 2.06623 0.187501L1.03097 0.187501C0.941235 0.187501 0.891681 0.290626 0.946591 0.360269L5.66222 6.39777C5.70224 6.44908 5.75345 6.4906 5.81193 6.51915C5.87041 6.5477 5.93464 6.56254 5.99972 6.56254C6.0648 6.56254 6.12902 6.5477 6.1875 6.51915C6.24599 6.4906 6.29719 6.44908 6.33722 6.39777Z",
  fill: "#6C767E"
});

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.efee336f.svg";
export { ForwardRef as ReactComponent };